"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const immer_1 = tslib_1.__importDefault(require("immer"));
const getState_1 = require("../../../helpers/getState");
const setVersionIdOfState_1 = tslib_1.__importDefault(require("../../../helpers/versions/setVersionIdOfState"));
const entity_1 = require("../../../type/entity");
const updateEnrolments_1 = tslib_1.__importDefault(require("../../applyAssignContent/updateEnrolments"));
const updateCurriculumChildContent_1 = require("../../helpers/updateCurriculumChildContent");
function applyUpdateContentOfCurriculumOffer(command, user, content, childContents, states, enrolments) {
    const events = [];
    const { rootContentId } = command;
    const updatedModel = immer_1.default({ states, enrolments }, inputModel => {
        let { states: draftStates, enrolments: draftEnrolments } = inputModel;
        const curriculumState = getState_1.getStateByContentIdUserId(draftStates, rootContentId, user.userId);
        if (curriculumState.completionStatus === entity_1.CompletionStatus.COMPLETE) {
            return;
        }
        const payload = updateCurriculumChildContent_1.updateCurriculumChildContents(command, content, childContents, draftStates, draftEnrolments, user);
        draftStates = payload.states;
        draftEnrolments = payload.enrolments;
        const contentState = getState_1.getStateByContentIdUserId(draftStates, content._id, user.userId);
        // update versionId in state
        setVersionIdOfState_1.default(command, content, contentState);
        draftEnrolments = updateEnrolments_1.default(draftEnrolments, command, content, user);
        events.push(...payload.events);
    });
    return {
        events,
        stateInteractions: [],
        states: updatedModel.states,
        enrolments: updatedModel.enrolments
    };
}
exports.applyUpdateContentOfCurriculumOffer = applyUpdateContentOfCurriculumOffer;
//# sourceMappingURL=index.js.map